import React from 'react';
import { Button, Result } from 'antd';

import { useNavigate } from '@tanstack/react-router';

const NotAuthorizedPage: React.FC = () => {
   const navigate = useNavigate();
  return (
    <>
      <Result
        status="500"
        title="Not Authorized"
        subTitle="Sorry, You do not have permission to access this page.."
        extra={<Button type="primary" onClick={() => navigate({ to: '..' })}>Go Back</Button>}
      />
    </>
  );
};

export default NotAuthorizedPage;